<!--字典管理-->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea DictionaryManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent clearfix">
        <!-- 内容左边区域 -->
        <div class="contentLeftArea">
          <!-- 添加设备类型 -->
          <div class="addDeviceArea clearfix">
            <span class="text">设备类型</span>
            <i class="icon el-icon-circle-plus-outline" @click="operateDialogInfo('addDevice')"></i>
          </div>
          <!-- 设备列表 -->
          <el-tree
            class="deviceListWrapper defineTree"
            v-loading="deviceData.loading"
            v-if="deviceData.list.length !== 0"
            :data="deviceData.list"
            node-key="device_id"
            default-expand-all
            @node-click="nodeClick"
            :props="defaultProps">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <!-- 自定义icon -->
              <i
                class="defineIcon"
                :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
              </i>
              <span
                :class="data.device_id === deviceData.now.deviceId || data.device_id === deviceData.now.parentDeviceId ? 'selected' : ''"
                class="label"
                @click="switchDevice(data.device_id, node)">{{ node.label }}</span>
              <!-- 添加二级、修改一级名称 -->
              <span
                class="operate"
                v-show="node.level === 1">
                <span class="text el-icon-edit-outline" @click.stop="operateDialogInfo('alterDevice', data)"></span>
                <span class="text ico ico-ic_playlist_add" @click.stop="operateDialogInfo('addDeviceTwo', data, node.device_id)"></span>
              </span>
              <!-- 修改二级设备名称、修改二级设备状态 -->
              <span
                class="operate"
                v-show="node.level !== 1">
                <span class="text el-icon-edit-outline" @click="operateDialogInfo('alterDeviceTwo' , data)"></span>
                <el-switch class="text" v-model="data.status" @change="changeDeviceStatus(data.device_id)"></el-switch>
              </span>
            </span>
          </el-tree>
          <!-- 设备列表为空 -->
          <p class="deviceNull" v-loading="deviceData.loading" v-else>暂时没有设备</p>
        </div>

        <!-- 内容右边区域 -->
        <div class="contentRightArea">
          <el-tabs v-model="deviceData.now.activeTab">

            <!-- 设备品牌 -->
            <el-tab-pane label="品牌" name="brand">
              <!-- 添加按钮 -->
              <el-button type="primary" class="addBtn" @click="operateDialogInfo('addBrand')">添 加</el-button>
              <!-- 表格信息 -->
              <el-table
                v-loading="allDataLoding"
                :data="allDataList.brand"
                style="width: 100%">
                <el-table-column
                  label="品牌名称"
                  prop="name"
                  width="100px">
                </el-table-column>

                <el-table-column
                  label="品牌代码"
                  prop="code"
                  width="150px">
                </el-table-column>

                <el-table-column
                  label="描述"
                  prop="desc"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="100px">
                  <template slot-scope="scope">
                    <el-button type="text" @click="operateDialogInfo('alterBrand',scope.row)">修改</el-button>
                    <el-button type="text" @click="operateDialogInfo('deleteBrand',scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <!-- 状态类别 -->
            <el-tab-pane label="状态类别" name="status">
              <!-- class为allotTree ，使用公共样式 -->
              <el-tree
                v-loading="allDataLoding"
                class="allotTree"
                ref="tree"
                :data="treeData.list"
                show-checkbox
                node-key="id"
                :default-checked-keys="treeData.active_list"
                :props="treeData.defaultProps"
                default-expand-all>
              </el-tree>
              <!-- 确认 -->
              <el-button
                class="confirm"
                type="primary"
                @click="getCheckedKeys"
                v-if="treeData.list.length !== 0">确 认</el-button>
            </el-tab-pane>

            <!-- 设备API列表 -->
            <el-tab-pane class="apiBox" label="API" name="api">
              <!-- 搜索框 -->
              <div class="searchBox clearfix">
                <el-select
                  class="selectApiList"
                  placeholder="请选择API"
                  v-model="selectApi.activeApi"
                  filterable
                  clearable >
                  <el-option
                    v-for="item in selectApi.list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <!-- 添加按钮 -->
                <el-button type="primary" class="addBtn" @click="updateDeviceApi()">添 加</el-button>
              </div>
              <!-- 表格信息 -->
              <el-table
                v-loading="allDataLoding"
                :data="allDataList.api"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="API名称">
                </el-table-column>
                <el-table-column
                  prop="type"
                  label="类型">
                </el-table-column>
                <el-table-column
                  prop="url"
                  label="地址"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="param"
                  label="参数">
                </el-table-column>
                <el-table-column
                  prop="post_type"
                  label="请求类型">
                </el-table-column>
                <el-table-column
                  prop="desc"
                  label="描述"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="operateDialogInfo('deleteApi',scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">

          <!-- 添加/修改设备 -->
          <div
            v-if="dialogData.type === 'addDevice' || dialogData.type === 'addDeviceTwo' || dialogData.type === 'alterDevice' || dialogData.type === 'alterDeviceTwo'">
            <el-form
              label-width="100px"
              :model="dialogData.info">
              <!-- 只在添加设备中显示 -->
              <el-form-item label="上级分类:" v-if="dialogData.type !== 'alterDevice'">
                <div class="inputBox">
                  <el-select
                    v-model="dialogData.info.parent_id"
                    placeholder="请选择"
                    :disabled="dialogData.type === 'addDeviceTwo'">
                    <el-option
                      label="/"
                      value="0">
                    </el-option>
                    <el-option
                      v-for="item in deviceData.list"
                      :key="item.device_id"
                      :label="item.name"
                      :value="item.device_id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.name"></el-input>
                </div>
              </el-form-item>
              <!-- 修改设备一级分类 -->
              <el-form-item label="配置类型:" v-if="dialogData.info.parent_id === '0'">
                <div class="inputBox">
                  <el-select
                    v-model="dialogData.info.type"
                    placeholder="请选择配置类型"
                    :disabled="dialogData.info.parent_id === '0' && dialogData.info.set_type === false">
                    <el-option
                      v-for="item in deviceData.typeList"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <!-- 修改二级设备场景类型 -->
              <el-form-item label="场景类型:" v-else>
                <div class="inputBox">
                  <el-select
                    v-model="dialogData.info.category"
                    placeholder="请选择场景类型">
                    <el-option label="智慧空间" value="1"></el-option>
                    <el-option label="智慧供应链" value="2"></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateDevice()">确 认</el-button>
            </div>
          </div>

          <!-- 添加/修改设备品牌 -->
          <div
            v-else-if="dialogData.type === 'addBrand' || dialogData.type === 'alterBrand'">
            <el-form
              label-width="100px"
              :model="dialogData.info">
              <el-form-item label="品牌名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.name"></el-input>
                </div>
              </el-form-item>

              <el-form-item label="品牌代码:">
                <div class="inputBox">
                  <el-input class="inputDeposit" :disabled="dialogData.type === 'alterBrand'" v-model="dialogData.info.code"></el-input>
                </div>
              </el-form-item>

              <el-form-item label="描述:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.desc"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateDeviceBrand()">确 认</el-button>
            </div>
          </div>

          <!-- 删除品牌 -->
          <div
            class="changeStatusWrapper"
            v-else-if="dialogData.type === 'deleteBrand'">
            <p class="text">
              删除
              <span class="bold">
                {{dialogData.info.name}}
              </span>
              品牌？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteDeviceBrand()">确认</el-button>
            </div>
          </div>

          <!-- 删除API -->
          <div v-else>
            <p class="text">
              删除
              <span class="bold">
                {{dialogData.info.name}}
              </span>
              API？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteDeviceApi()">确认</el-button>
            </div>
          </div>

        </el-dialog>
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { showToast, deepCopy } from "../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../static/js/api.js"

  export default {
    name: 'DictionaryManage',
    components: {
      BreadCrumb
    },
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 设备数据
        deviceData: {
          // 设备列表
          list: [],
          // 当前显示设备
          now: {
            // 设备id
            deviceId: '',
            // 设备父级id
            parentDeviceId: '',
            // 右侧tab显示，默认首次显示品牌
            activeTab: 'brand'
            // activeTab: 'api'
          },
          // 配置类型列表
          typeList: [
            {
              name: '柜类',
              type: '1'
            },
            {
              name: '门禁',
              type: '2'
            },
            {
              name: '其他',
              type: '3'
            }
          ],
          loading: false
        },
        // 品牌、状态、api数据
        allDataList: {},
        allDataLoding: false,
        // 状态类别数据
        treeData: {
          // 列表
          list: [],
          // 	已选类别
          active_list: [],
          defaultProps: {
            children: 'children',
            label: 'name'
          }
        },
        // 待选api列表
        selectApi: {
          list: [],
          activeApi: ''
        },
        // 树形控件配置
        defaultProps: {
          children: 'children',
          label: 'name'
        }
      }
    },
    mounted(){
      this.getDeviceList()
    },
    created: async function () {
    },
    methods: {
      // 操作对话框信息（添加或修改）dialogData
      operateDialogInfo: function (type, info, parent_id) {
        console.log('type', type)
        let addDeviceInfo = {
          device_id: '',
          name: '',
          parent_id: type === 'addDeviceTwo' ? info.device_id : '0'
        }
        console.log('addDeviceInfo', addDeviceInfo)
        let addBrandInfo = {
          device_id: '',
          name: '',
          desc: ''
        }
        let title = type === 'addDevice' || type === 'addDeviceTwo' ? '添加设备' :
                    type === 'alterDevice' || type === 'alterDeviceTwo' ? '修改设备' :
                    type === 'alterDeviceName' ? '修改品牌名称' :
                    type === 'addBrand' ? '添加品牌' : type === 'alterBrand' ? '修改品牌' :
                    type === 'deleteBrand' ? '删除品牌' : '删除API'
        this.dialogData = {
          type: type,
          title: title,
          visible: !(this.dialogData.visible),
          isReset: false,
          info: type === 'addDevice' || type === 'addDeviceTwo' ? addDeviceInfo : type === 'addBrand' ? addBrandInfo : deepCopy(info)
        }
        console.log('this', this.dialogData)
      },

      // 更新（添加/修改)设备品牌
      updateDeviceBrand: async function() {
        let vm = this
        let data = {
          device_id: vm.deviceData.now.deviceId,
          id: vm.dialogData.info.id,
          name: vm.dialogData.info.name,
          code: vm.dialogData.info.code,
          desc: vm.dialogData.info.desc
        }

        console.log('更新数据', data)
        // return

        if(data.name === '') {
          showToast('品牌名称不能为空！')
          return
        }

        if(data.code === '') {
          showToast('品牌代码不能为空！')
          return
        }

        if(data.desc === '') {
          showToast('描述不能为空！')
          return
        }

        let res = await systemApi.updateDeviceBrand(data)
        if (res.meta.code === 200) {
          showToast(vm.dialogData.type === 'addBrand' ? '添加成功' : '修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getAllDataList()
        } else {
          showToast(res.meta.message)
        }
      },

      // 删除设备品牌
      deleteDeviceBrand: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.info.id
        }

        let res = await systemApi.deleteDeviceBrand(data)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getAllDataList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 确认修改状态列表
      getCheckedKeys() {
        console.log(this.$refs.tree.getCheckedKeys())
        let arr = this.$refs.tree.getCheckedKeys()
        let statusArr = []
        for (let i in arr) {
          // 筛选为undefined的id值
          if (arr[i] !== undefined) {
            statusArr.push(arr[i])
          }
        }
        console.log('statusArr', statusArr)
        this.updateDeviceStatus(statusArr)
      },
      // 更新状态类别
      updateDeviceStatus: async function (statusArr) {
        let vm = this 
        let data = {
          device_id: vm.deviceData.now.deviceId,
          status: statusArr
        }

        let res = await systemApi.updateDeviceStatus(data)
        if (res.meta.code === 200) {
          showToast('修改成功')
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取待选api列表
      getSelectApiList: async function () {
        let vm = this
        let data = {
          device_id: vm.deviceData.now.deviceId
        }

        let res = await systemApi.getSelectApiList(data)
        if (res.meta.code === 200) {
          vm.selectApi.list = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理所有数据列表信息
      processAllData: function (data) {
        let vm = this
        let statusList = data.status
        vm.treeData.active_list = []
        // console.log('statusList', statusList)
        
        for (let i in statusList) {
          let children = statusList[i].children
          for (let j in children) {
            let status = children[j].status
            // console.log('status--', status)
            if (status === true) {
              // 获取已选中的列表
              vm.treeData.active_list.push(children[j].id)
            }
          }
        }

        // console.log('vm.treeData.active_list', vm.treeData.active_list)
        vm.treeData.list = statusList
        vm.allDataList = data
        // this.$forceUpdate()
        
      },
      // 获取设备品牌/api/状态所有数据列表
      getAllDataList: async function () {
        let vm = this
        let data = {
          device_id: vm.deviceData.now.deviceId
        }

        vm.allDataLoding = true
        let res = await systemApi.getAllDataList(data)
        vm.allDataLoding = false
        if (res.meta.code === 200) {
          // vm.allDataList = res.data
          vm.processAllData(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 添加设备Api
      updateDeviceApi: async function () {
        let vm = this
        let data = {
          device_id: vm.deviceData.now.deviceId,
          api_id: vm.selectApi.activeApi
        }

        console.log('更新数据', data)
        // return

        if(data.api_id === '') {
          showToast('请选择API')
          return
        }

        let res = await systemApi.updateDeviceApi(data)
        if (res.meta.code === 200) {
          showToast('添加成功')
          vm.selectApi.activeApi = ''
          vm.getSelectApiList()
          vm.getAllDataList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 删除设备API
      deleteDeviceApi: async function () {
        let vm = this
        let data = {
          device_id: vm.deviceData.now.deviceId,
          api_id: vm.dialogData.info.id
        }

        let res = await systemApi.deleteDeviceApi(data)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getAllDataList()
          vm.getSelectApiList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 修改设备状态
      changeDeviceStatus: async function (device_id) {
        let vm = this
        let data = {
          device_id: device_id
        }

        let res = await systemApi.changeDeviceStatus(data)
        if (res.meta.code === 200) {
          console.log('修改状态成功')
          // vm.getDeviceList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 显示/隐藏二级菜单
      changeTreeIcon: function (index, treeIcon) {
        // console.log('index', index)
        // console.log('treeIcon', treeIcon)
        if (treeIcon === 'el-icon-plus') {
          this.deviceData.list[index].treeIcon = 'el-icon-minus'
        } else {
          this.deviceData.list[index].treeIcon = 'el-icon-plus'
        }
      },
      // 更新（添加/修改）设备
      updateDevice: async function () {
        let vm = this
        let data = {
          device_id: vm.dialogData.type === 'addDevice' ? '' : vm.dialogData.info.device_id,
          name: vm.dialogData.info.name,
          parent_id: vm.dialogData.info.parent_id,
          type: vm.dialogData.info.type,
          category: vm.dialogData.info.category
        }
        console.log('更新数据', data)
        // return

        if (data.parent_id === '') {
          showToast('请选择上级分类！')
          return
        }
        if (data.name === '') {
          showToast('名称不能为空！')
          return
        }
        if (data.parent_id === '0'){
          if (data.type === '' || data.type === undefined) {
            showToast('请选择配置类型！')
            return
          }
        } else {
          console.log('category', data.category)
          if (data.category === '' || data.category === undefined) {
            showToast('请选择场景类型！')
            return
          }
        }

        let res = await systemApi.updateDevice(data)
        if (res.meta.code === 200) {
          showToast(vm.dialogData.type.indexOf('add') !== -1 ? '添加成功' : '修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getDeviceList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理设备列表数据
      processDeviceData: function (data) {
        let vm = this
        let list = [...data]
        vm.deviceData.now.deviceId = list[0].children[0].device_id
        vm.deviceData.now.parentDeviceId = list[0].device_id
        vm.deviceData.list = [...list]
        console.log('设备信息', vm.deviceData)
      },
      // 获取设备列表
      getDeviceList: async function () {
        let vm = this

        vm.deviceData.loading = true
        let res = await systemApi.getDeviceList()
        vm.deviceData.loading = false
        if (res.meta.code === 200) {
          // console.log('tag', res.data, res.data.length)
          if (res.data.length === 0) {
            vm.deviceData.list = res.data
          } else {
            // vm.processDeviceData(res.data)
            vm.processDeviceData(res.data)
          }
        } else {
          showToast(res.meta.message)
        }
      },
      // 树节点点击，切换设备
      nodeClick: function (data, node) {
        if (node.level === 1) {
          return
        }
        this.switchDevice(data.device_id, node)
      },
      // 切换设备
      switchDevice: function (device_id, node) {
        // return
        let vm = this
        if (node.level === 1) {
          return
        }
        // 获取最新的设备id
        vm.deviceData.now.deviceId = device_id
        vm.deviceData.now.parentDeviceId = node.parent.data.device_id
      },
    },
    watch: {
      // 监听当前设备id的值变化，更新右边所有信息列表
      "deviceData.now.deviceId": function(newVal) {
        this.getAllDataList()
        this.getSelectApiList()
      }
    }
  }
</script>

<style lang="scss" scoped>
.DictionaryManage {
  .mainBodyContent::after{
    height: 100%;
    content: '';
    border-right: 1px solid #E4E7ED;
    visibility: visible;
    position: absolute;
    left: 250px;
    top: 0;
  }
  .mainBodyContent{
    padding: 0;
    position: relative;
    .contentLeftArea {
      float: left;
      width: 250px;
      padding-bottom: 10px;
      // 添加
      .addDeviceArea{
        width: 100%;
        line-height: 40px;
        padding: 0 20px 0 10px;
        border-bottom: 1px solid #E4E7ED;
        .text{
          float: left;
        }
        .icon {
          float: right;
          display: block;
          font-size: 20px;
          line-height: 40px;
        }
      }
      // 设备列表
      .deviceListWrapper {
        padding: 10px;
      }
      // 没有设备
      .deviceNull {
        text-align: center;
        margin-top: 100px;
      }
    }
    .contentRightArea {
      padding: 10px;
      margin-left: 280px;
      .addBtn {
        margin-bottom: 10px;
      }
      .apiBox {
        .searchBox {
          .selectApiList {
            float: left;
            margin-right: 30px;
          }
          .addBtn {
            float: left;
          }
        }
      }
    }
  }
}

.el-tree.defineTree .custom-tree-node {
  width: 100%;
  .operate{
    .text {
      font-size: 20px;
      float: right;
    }
    .text:first-child{
      margin-right: 0;
      margin-left: 10px;
    }
    .text.ico {
      width: 40px;
      text-align: center;
      font-size: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/System/DictionaryManage.vue